var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53058 4.87195C9.52921 6.11473 9.03492 7.30622 8.15613 8.185C7.27735 9.06379 6.08586 9.55808 4.84308 9.55945H0.89011C0.695376 9.5592 0.508689 9.48173 0.370992 9.34404C0.233294 9.20634 0.155827 9.01965 0.155579 8.82492V4.87195C0.155579 3.62875 0.649439 2.43646 1.52852 1.55739C2.40759 0.678308 3.59988 0.184448 4.84308 0.184448C6.08628 0.184448 7.27856 0.678308 8.15764 1.55739C9.03672 2.43646 9.53058 3.62875 9.53058 4.87195Z",
    fill: "#848874"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsFilled);
export default __webpack_public_path__ + "static/media/commentsFilled.26bc6a912efcd408d886203a94d6c1a0.svg";
export { ForwardRef as ReactComponent };